import { render } from "./ProductTerms.vue?vue&type=template&id=3e739bf0&scoped=true"
import script from "./ProductTerms.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductTerms.vue?vue&type=script&setup=true&lang=js"

import "./ProductTerms.vue?vue&type=style&index=0&id=3e739bf0&lang=scss&scoped=true"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e739bf0"],['__file',"src/components/ProductTerms.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3e739bf0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3e739bf0', __exports__)) {
    console.log('reload')
    api.reload('3e739bf0', __exports__)
  }
  
  module.hot.accept("./ProductTerms.vue?vue&type=template&id=3e739bf0&scoped=true", () => {
    console.log('re-render')
    api.rerender('3e739bf0', render)
  })

}


export default __exports__